import { useEffect, useState } from 'react';
import { CATALOG_STATS } from '../data/dummyCatalog';
import {
  searchCarsFromCatalog,
  searchCruisesFromCatalog,
  searchHotelsFromCatalog,
  searchPackagesFromCatalog,
} from '../utils/catalogSearch';
import { generateFlightResults } from '../utils/searchResults';

/**
 * Dummy-only travel search — no live APIs.
 */
export function useTravelSearch(type, params, { enabled = true } = {}) {
  const [loading, setLoading] = useState(enabled);
  const [results, setResults] = useState([]);
  const [catalogInfo, setCatalogInfo] = useState(null);

  const paramKey = JSON.stringify(params);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      setResults([]);
      setCatalogInfo(null);
      return undefined;
    }

    let cancelled = false;
    const timer = window.setTimeout(() => {
      let data = [];
      let info = null;

      if (type === 'flights') {
        data = generateFlightResults(params);
        info = `${data.length} sample flights for this route`;
      } else if (type === 'hotels') {
        data = searchHotelsFromCatalog(params, 80);
        info = `${CATALOG_STATS.hotels.toLocaleString()}+ hotels in catalog`;
      } else if (type === 'cars') {
        data = searchCarsFromCatalog(params, 80);
        info = `${CATALOG_STATS.cars.toLocaleString()}+ rentals in catalog`;
      } else if (type === 'packages') {
        data = searchPackagesFromCatalog(params, 80);
        info = `${CATALOG_STATS.packages.toLocaleString()}+ packages in catalog`;
      } else if (type === 'cruises') {
        data = searchCruisesFromCatalog(params, 80);
        info = `${CATALOG_STATS.cruises.toLocaleString()}+ cruises in catalog`;
      }

      if (!cancelled) {
        setResults(data);
        setCatalogInfo(info);
        setLoading(false);
      }
    }, 450);

    setLoading(true);
    setCatalogInfo(null);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [type, paramKey, enabled]);

  return {
    loading,
    results,
    source: 'demo',
    error: null,
    catalogInfo,
    isLive: false,
  };
}
